import { ListeColumnType, ListeTable } from '@mairistem/liste';
import _ from 'lodash';
import React from 'react';

import { ETATS_FACTURE } from '@/constants';
import { RegieContext } from '@/contexts';
import type { CycleType } from '@/types';

type FacturesListeTableHeaderProps = {
  cycles?: CycleType[];
  [key: string]: any;
};

const FacturesListeTableHeader = (props: FacturesListeTableHeaderProps) => {
  const { cycles, ...rest } = props;
  const cyclesTitres = React.useMemo(() => _.map(cycles, ({ titre }) => titre), [cycles]);

  const { regies, selectedRegie } = React.useContext(RegieContext);

  const { logicielsFacturier } = _.find(regies, { identifiant: selectedRegie }) || {};

  // Si 1 seul logiciel facturier, on masque la colonne
  const hideSourceColumn = _.size(logicielsFacturier) <= 1;

  return (
    <>
      <ListeTable.Column
        {...rest}
        name="numero"
        type={ListeColumnType.STRING}
        sortable
        verticalAlign="middle"
        style={{ width: 175 }}
      >
        N°
      </ListeTable.Column>
      <ListeTable.Column
        {...rest}
        name="nomPayeur"
        type={ListeColumnType.STRING}
        sortable
        verticalAlign="middle"
      >
        Nom du payeur
      </ListeTable.Column>
      <ListeTable.Column
        {...rest}
        name="nomFacturation"
        type={ListeColumnType.STRING}
        sortable
        verticalAlign="middle"
      >
        Nom de
        <br />
        facturation
      </ListeTable.Column>
      <ListeTable.Column
        {...rest}
        name="adresseFacturation"
        type={ListeColumnType.STRING}
        sortable
        style={{ width: 200 }}
        verticalAlign="middle"
      >
        Adresse de
        <br />
        facturation
      </ListeTable.Column>
      <ListeTable.Column
        {...rest}
        name="cycleFacturation"
        type={ListeColumnType.STRING}
        sortable
        verticalAlign="middle"
        filtersDefaultActive="DANS_LISTE"
        filtersValues={{
          DANS_LISTE: cyclesTitres,
        }}
      >
        Cycle de
        <br />
        facturation
      </ListeTable.Column>
      {!hideSourceColumn && (
        <ListeTable.Column
          {...rest}
          name="source"
          type={ListeColumnType.STRING}
          sortable
          style={{ width: 90 }}
          verticalAlign="middle"
          filtersDefaultActive="DANS_LISTE"
          filtersValues={{
            DANS_LISTE: _.map(logicielsFacturier, ({ code }) => code),
          }}
        >
          App
        </ListeTable.Column>
      )}
      <ListeTable.Column
        {...rest}
        name="dateFacture"
        type={ListeColumnType.DATE}
        sortable
        verticalAlign="middle"
        style={{ width: 120 }}
      >
        Date
        <br />
        limite
      </ListeTable.Column>
      <ListeTable.Column
        {...rest}
        name="montantAEncaisser"
        type={ListeColumnType.NUMBER}
        sortable
        style={{ width: 130 }}
        verticalAlign="middle"
      >
        Montant à
        <br />
        encaisser
      </ListeTable.Column>
      <ListeTable.Column
        {...rest}
        name="etat"
        type={ListeColumnType.STRING}
        sortable
        verticalAlign="middle"
        style={{ width: 200 }}
        filtersDefaultActive="DANS_LISTE"
        filtersDefaultValues={{
          DANS_LISTE: [ETATS_FACTURE.A_ENCAISSER, ETATS_FACTURE.ENCAISSEMENT_PARTIEL],
        }}
        filtersValues={{
          DANS_LISTE: [ETATS_FACTURE.A_ENCAISSER, ETATS_FACTURE.ENCAISSEMENT_PARTIEL],
        }}
      >
        État facture
      </ListeTable.Column>
    </>
  );
};

export default FacturesListeTableHeader;
